import React, { useEffect, useState } from 'react';
import { ToggleButtonGroup, OverlayTrigger, Badge } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import { FiltersButton } from './FiltersButton';
import { Envelope, Book, Cursor, QuestionCircle, InfoCircle, Activity } from 'react-bootstrap-icons';

interface MessageComposeFiltersProps {
  onFilterChange: (filter: string) => void;
  disabled?: boolean; // Add a disabled prop
}

export enum MessageComposeFilterTypes {
  inquiry = 'general inquiry',
  missinginfo = 'missing information',
  status = 'status'
}

const availableFilters = Object.keys(MessageComposeFilterTypes);

export const MessageComposeFilters = (props: MessageComposeFiltersProps) => {
  const { hash } = useLocation();
  const history = useHistory();

  const filter = ((hash && availableFilters.find((f) => hash.includes(f))) || null) ?? null;

  const [selectedFilter, setSelectedFilter] = useState<string | null>(null);

  const onFilterChange = (newFilter: string) => {
    if (props.disabled) return;
    history.push(`#${newFilter}`);
    setSelectedFilter(newFilter);
    props.onFilterChange(newFilter);
  };

  //   useEffect(() => {
  //     if (!selectedFilter) return;
  //     history.replace(`#${selectedFilter}`);
  //   }, [props.onFilterChange, selectedFilter]);

  const renderFilterButton = (label: string, value: string, icon: React.ReactNode) => {
    const isSelected = selectedFilter === value;
    const badgeVariant = isSelected ? 'secondary' : '';
    return (
      <Badge
        pill
        bg={badgeVariant}
        className='d-flex align-items-center px-3 py-2'
        style={{
          cursor: 'pointer',
          justifyContent: 'space-between',
          gap: '3px',
          backgroundColor: isSelected ? '' : '#E7F1FF',
          color: isSelected ? '#FFFFFF' : '#115099',
          opacity: props.disabled ? 0.6 : 1
        }}
        onClick={(e: React.MouseEvent<HTMLSpanElement>) => {
          e.preventDefault();
          onFilterChange(value);
        }}>
        {icon}
        {label}
      </Badge>
    );
  };

  return (
    <div className='d-flex align-items-center'>
      <ToggleButtonGroup name='patients-filters' type='radio' style={{ gap: '10px' }} aria-disabled='true'>
        {renderFilterButton('General Inquiry', MessageComposeFilterTypes.inquiry, <QuestionCircle />)}
        {renderFilterButton('Missing Information', MessageComposeFilterTypes.missinginfo, <InfoCircle color='black' />)}
        {renderFilterButton('Status', MessageComposeFilterTypes.status, <Activity />)}
      </ToggleButtonGroup>
    </div>
  );
};
